module.exports = __webpack_public_path__ + "img/photo-28.0205c7d0.png";